import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Snowflake, ShieldCheck, ThermometerSnowflake, ArrowRight } from "lucide-react";
export default function HeroNepean() {
  const features = [{
    icon: <ThermometerSnowflake className="size-6 text-secondary" />,
    title: "Furniture & Appliances",
    description: "Safe removal of heavy sofas, old fridges, and bulky household items."
  }, {
    icon: <ShieldCheck className="size-6 text-secondary" />,
    title: "Renovation Debris",
    description: "Efficient cleanup of construction waste, drywall, and flooring materials."
  }, {
    icon: <Snowflake className="size-6 text-secondary" />,
    title: "Same Day Pickup",
    description: "Fast response times for urgent junk removal needs across Nepean."
  }];
  return <section data-section-id="252679" id="hero-nepean" className="bg-background text-foreground w-full">
      <div className="bg-primary text-primary-foreground relative overflow-hidden">
        {}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5">
          <div className="absolute top-10 left-[10%] animate-pulse">
            <ShieldCheck className="size-24" />
          </div>
          <div className="absolute top-40 right-[20%] animate-pulse delay-700">
            <ShieldCheck className="size-16" />
          </div>
          <div className="absolute bottom-20 left-[30%] animate-pulse delay-1000">
            <ShieldCheck className="size-32" />
          </div>
        </div>

        <div className="page-container relative z-10 py-16 md:py-24 lg:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {}
            <div className="flex flex-col space-y-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-secondary/20 text-secondary w-fit border border-secondary/30">
                <ShieldCheck className="size-4" />
                <span className="text-sm font-bold tracking-wide uppercase font-sans">Local Nepean Service</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-[68px] leading-tight font-bold font-default text-primary-foreground">
                Junk Removal Nepean
              </h1>
              
              <p className="text-lg md:text-[20px] text-primary-foreground/90 font-sans max-w-xl leading-relaxed">
                Fast affordable junk removal in Nepean with same day pickups available for furniture, appliances, renovation debris, mattresses, and household junk.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button asChild size="lg" className="text-base h-14 px-8 rounded-md shadow-lg bg-secondary text-secondary-foreground hover:bg-secondary/90">
                  <Link to="/PricingPage">
                    Get a Free Quote
                    <ArrowRight className="ml-2 size-5" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="text-base h-14 px-8 rounded-md bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                  <Link to="#">
                    Text Us Photos
                  </Link>
                </Button>
              </div>

              {}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-primary-foreground/20 mt-8">
                {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
                    <div className="p-3 bg-primary-foreground/10 rounded-md w-fit">
                      {feature.icon}
                    </div>
                    <h3 className="font-default font-semibold text-primary-foreground text-lg">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-primary-foreground/80 font-sans">
                      {feature.description}
                    </p>
                  </div>)}
              </div>
            </div>

            {}
            <div className="relative lg:ml-auto w-full max-w-lg">
              <div className="absolute -inset-4 bg-secondary/20 rounded-2xl blur-2xl transform -rotate-3"></div>
              <div className="relative rounded-lg overflow-hidden border-4 border-primary-foreground/10 shadow-2xl">
                <AspectRatio ratio={4 / 5}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/nepean_junk_removal_team.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/nepean_junk_removal_team.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/nepean_junk_removal_team.png-wvc-sizes" alt="Two workers in black polos carrying furniture near a branded junk removal truck" className="object-cover w-full h-full" loading="lazy" />
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent"></div>
                </AspectRatio>
                
                {}
                <div className="absolute bottom-6 left-6 right-6 bg-card/95 backdrop-blur-sm p-4 rounded-md border border-border shadow-lg flex items-center gap-4">
                  <div className="bg-secondary/10 p-3 rounded-md">
                    <ShieldCheck className="size-8 text-secondary" />
                  </div>
                  <div>
                    <p className="font-default font-bold text-card-foreground text-lg">Fully Insured</p>
                    <p className="text-sm text-muted-foreground font-sans">Professional & Reliable</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}